import React, { useEffect, useState } from "react";
import LeaveImg from "../assets/images/Leav-img.png";
import zithasLogo from "../assets/images/zithas-logoUK.png";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { config, FetchPostData } from "../config";
import secureLocalStorage from "react-secure-storage";
import Loader from "../components/Loader";
import { Modal } from "antd";

const ApplyLeave = () => {
    const today = new Date().toISOString().split('T')[0];
    const navigate = useNavigate();
    const userData = secureLocalStorage.getItem('user')
    const [start_date, setStartDate] = useState('')
    const [end_date, setEndDate] = useState('')
    const [reason, setReason] = useState('')
    const [type, setType] = useState('')
    const [halfDay, setHalfDay] = useState(false)
    const [file, setFile] = useState('')
    const [loading, setLoading] = useState(false)
    const [succesPop, setSuccesPop] = useState(false)
    const [leaveId, setLeaveId] = useState('')
    const toggleLoading = (loading) => {
        setLoading(loading)
    }
    useEffect(() => {
        if (userData == null) {
            navigate(`${config.appUrl}`)
        }
    }, [])
    const onSubmitApplication = async (e) => {
        e.preventDefault();
        const formDatas = {
            user_id: userData?.user_id,
            start_date: start_date,
            end_date: end_date,
            leave: type,
            reason: reason,
            file: file,
            half_day: halfDay == true ? 1 : 0,
        }
        const response = await FetchPostData(toggleLoading, "applyLeave", userData?.token, formDatas);
        if (response?.data?.success) {
            setLeaveId(response?.data?.leave_id)
            setSuccesPop(true);
        }
    }


    return (
        <div>
            {loading && (<Loader />)}
            <div className="bg-light-purple">
                <div className="container h-100vh mobile-h-100">
                    <div className="bg-light-purple">
                        <div className="row h-100vh mobile-h-100 align-items-center">
                            <div className="col-md-5 bd-responsive-none">
                                <div>
                                    <img src={LeaveImg} alt="Login" className="" width="400" />
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className="mb-2">
                                    <div className="mb-3 text-center">
                                        <img src={zithasLogo} alt="Zithas Logo" width="210" />
                                    </div>

                                    <div className="login-side text-center leave-side">
                                        <h3 className="mb-2">Leave Management System</h3>

                                        <div className="d-flex gap-3 total-leave mt-4 res-flex-column">
                                            <div>
                                                <p className="mb-0">{userData?.name}</p>
                                            </div>
                                            <div className="d-flex gap-2 justify-content-center">
                                                <p className="mb-0">Sick Leaves: {userData?.sick_leave} ,</p>
                                                <p className="mb-0">Casual Leaves : {userData?.casual_leave}</p>
                                            </div>
                                        </div>
                                        <form className="login-form mt-4" onSubmit={onSubmitApplication}>
                                            <div>
                                                <div className="row">
                                                    <div className="col-md-4 mb-3 custom-date">
                                                        <label className="form-label">Start Date <span className="text-danger">*</span></label>
                                                        <input
                                                            type="date"
                                                            className="form-control custom-control"
                                                            required
                                                            min={today}
                                                            value={start_date}
                                                            onChange={(e) => {
                                                                setStartDate(e.target.value)
                                                                setEndDate('')
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col-md-4 mb-3 custom-date">
                                                        <label className="form-label">End Date <span className="text-danger">*</span></label>
                                                        <input
                                                            min={start_date}
                                                            type="date"
                                                            className="form-control custom-control"
                                                            value={end_date}
                                                            onChange={(e) => setEndDate(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                    <div class="col-md-4 mb-3 custom-type">
                                                        <div className="d-flex gap-3 ">
                                                            <div className="text-center">
                                                                <label className="form-label">Half Day </label><br />
                                                                <input
                                                                    type="checkbox"
                                                                    name="type"
                                                                    value={halfDay}
                                                                    onChange={(e) => {
                                                                        setHalfDay(e.target.checked)
                                                                    }}
                                                                />
                                                            </div>
                                                            <div>
                                                                <label className="form-label">Leave Type <span className="text-danger">*</span></label>
                                                                <div className="d-flex gap-3 ">
                                                                    <div>
                                                                        <input
                                                                            type="radio"
                                                                            id="sick"
                                                                            name="type"
                                                                            value="1"
                                                                            required
                                                                            onChange={(e) => setType('1')}
                                                                        />
                                                                        <label for="sick" className="form-label ps-1">
                                                                            <strong>Sick </strong>
                                                                        </label>
                                                                    </div>
                                                                    <div>
                                                                        <input
                                                                            type="radio"
                                                                            id="casual"
                                                                            name="type"
                                                                            value="3"
                                                                            required
                                                                            onChange={(e) => setType('3')}
                                                                        />
                                                                        <label for="casual" className="form-label ps-1">
                                                                            <strong> Casual </strong>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mb-3">
                                                        <label className="form-label">Reason of Leave <span className="text-danger">*</span></label>
                                                        <textarea
                                                            className="form-control custom-control textarea"
                                                            placeholder="Enter Reason of Leave"
                                                            rows="4"
                                                            required
                                                            value={reason}
                                                            onChange={(e) => setReason(e.target.value)}
                                                        ></textarea>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label">Upload Related file</label>
                                                        <input
                                                            type="file"
                                                            className="form-control custom-control"
                                                            onChange={(e) => setFile(e.target.files[0])}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="mt-3">
                                                    <button className="leave-button">
                                                        Submit Leave Application
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                title=""
                open={succesPop}
                footer=""
            >
                <div className="modal-body">
                    <div>
                        <div className="text-center"><i className="bi bi-check2-circle bd-check text-success"></i></div>
                        <h4 className="text-center">Application  submitted successfully</h4>
                        <p className="text-center mb-2">Your Leave Application has been submitted successfully.</p>
                        <p className="text-center text-danger fw-bold">Take a Screenshot and send it to the HR</p>
                        <p className="text-center">
                            <strong>Name</strong>: {userData?.name} <br /> <strong>Leave Id</strong> : {leaveId}
                        </p>
                        <button className="leave-button"
                            onClick={() => {
                                setSuccesPop(false);
                                secureLocalStorage.removeItem('user');
                                navigate(`${config.appUrl}`)
                            }}>
                            Okay <i className="bi bi-hand-thumbs-up-fill"></i></button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default ApplyLeave;
